import { useContext, useMemo } from 'react';
import { FeaturedFlagsContext, FeaturedFlagsUnion } from './FeaturedFlagsContext';

export const useFeaturedFlags = (featuredFlags: FeaturedFlagsUnion[]): boolean[] => {
  const { enabledFeatures } = useContext(FeaturedFlagsContext);

  return useMemo(() => featuredFlags.map((f) => enabledFeatures.includes(f)), [enabledFeatures]);
};

export const enum COMPUTE_RESOUCE {
  BASE = 'ComputeOrchestration',
  LOCAL = 'ComputeResourceLocal',
  SMALL = 'ComputeResourceSmall',
  MEDIUM = 'ComputeResourceMedium',
  LARGE = 'ComputeResourceLarge',
}

export type ComputeResourceAccess = {
  hasBaseAccess: boolean;
  hasLocalAccess: boolean;
  hasSmallAccess: boolean;
  hasMediumAccess: boolean;
  hasLargeAccess: boolean;
  hasResourceAccess: boolean;
};

export const useComputeAccess = (): ComputeResourceAccess => {
  const { enabledFeatures } = useContext(FeaturedFlagsContext);

  return useMemo(() => {
    const hasBaseAccess = enabledFeatures.includes('ComputeOrchestration');
    const hasLocalAccess = enabledFeatures.includes('ComputeResourceLocal');
    const hasSmallAccess = enabledFeatures.includes('ComputeResourceSmall');
    const hasMediumAccess = enabledFeatures.includes('ComputeResourceMedium');
    const hasLargeAccess = enabledFeatures.includes('ComputeResourceLarge');

    // hasResourceAccess is true if at least one of SMALL, MEDIUM, or LARGE is set
    const hasResourceAccess = hasSmallAccess || hasMediumAccess || hasLargeAccess;

    return {
      hasBaseAccess,
      hasLocalAccess,
      hasSmallAccess,
      hasMediumAccess,
      hasLargeAccess,
      hasResourceAccess,
    };
  }, [enabledFeatures]);
};
